import { useRef, useState, useCallback, useEffect, Fragment  } from 'react';
import { connect } from 'react-redux';

import { SET_CONFIRM_SHARE_SCHEDULE_WORK_DATES_DIALOGUE_OPEN, SiteboardApiValidator, CONFIRM_SHARE_SCHEDULE_DATES, SET_ALERT, SET_SHARE_SCHEDULE_CONFIRMED, } from '../actions/types';
import { siteboardAction, setLoading, } from '../actions/defaultActions';
import { objectValuesToList, objectKeysToList, keyCountInObject, getServerApiResponse, } from '../Util';
import { format } from 'date-fns';

import PopupWindow from './PopupWindow';
import PushButton from './PushButton';

// icon imports
import CalendarIcon from '../icons/calendarIcon';
import CircleCheckIcon from '../icons/circleCheckIcon';

// test cases
const testNoEmails = false;

const ConfirmWorkDatesDialogue = ({ _confirmWorkDatesDialogueEmail, _confirmWorkDatesDialogueFirstName, _confirmWorkDatesDialogueLastName, _confirmWorkDatesDialogueCompanyName, _confirmWorkDatesDialogueShareScheduleCode, _shareScheduleConfirmed, siteboardAction, setLoading, }) => {

  const closeDialogue = useCallback(() => {
    siteboardAction(SET_CONFIRM_SHARE_SCHEDULE_WORK_DATES_DIALOGUE_OPEN, {
      isOpen: false,
      email: _confirmWorkDatesDialogueEmail,
      firstName: _confirmWorkDatesDialogueFirstName,
      lastName: _confirmWorkDatesDialogueLastName,
      companyName: _confirmWorkDatesDialogueCompanyName,
      shareCode: _confirmWorkDatesDialogueShareScheduleCode,
    });
  }, [siteboardAction, _confirmWorkDatesDialogueEmail, _confirmWorkDatesDialogueFirstName, _confirmWorkDatesDialogueLastName, _confirmWorkDatesDialogueCompanyName, _confirmWorkDatesDialogueShareScheduleCode]);

  const confirmedShareScheduleContactDates = (isConfirmed) => {
    let apiArgs = null;
    try {
      apiArgs = SiteboardApiValidator[CONFIRM_SHARE_SCHEDULE_DATES].validateInput({
        action: CONFIRM_SHARE_SCHEDULE_DATES,
        shareCode: _confirmWorkDatesDialogueShareScheduleCode,
        isConfirmed: isConfirmed === true,
      });
    } catch(error) {
      siteboardAction(SET_ALERT, { message: error.message }); 
      return;
    }

    const onApiSuccess = (data) => {
      setLoading('');
      try {
        const validOutput = SiteboardApiValidator[CONFIRM_SHARE_SCHEDULE_DATES].validateOutput(data); 
        siteboardAction(SET_SHARE_SCHEDULE_CONFIRMED, { isConfirmed: validOutput.isConfirmed });
      } catch(error) {
        onApiError(error.message);
      }
    };
    const onApiError = (errorMessage) => {
      setLoading('');
      siteboardAction(SET_ALERT, { message: typeof errorMessage === 'string' ? errorMessage : 'There was an error confirming your scheduled dates.' }); 
    };
    setLoading(`${isConfirmed === true ? 'Confirming ' : 'Un-Confirming '} Your Scheduled Dates`);
    getServerApiResponse(apiArgs, onApiSuccess, onApiError);
  }
  return (
    <PopupWindow 
      title={'Confirm Work Dates'}
      closeDialogue={closeDialogue}
      bgStyle='bg-[#333]'
    >
      <div className={`max-w-screen-sm bg-[#333] text-white`}>
        {_shareScheduleConfirmed ?
          <div className='flex flex-col gap-4'>
            <div className='flex items-start gap-2 text-[1.2em]'>
              <CircleCheckIcon size='1.4em' color='#00bc7d' />
              <div>Dates confirmed for: </div>
            </div>
            <div className='font-bold p-2'>
              <div>{_confirmWorkDatesDialogueCompanyName}</div>
              <div>{_confirmWorkDatesDialogueFirstName} {_confirmWorkDatesDialogueLastName}</div>
              <div>{_confirmWorkDatesDialogueEmail}</div>
            </div>
            <div>
              Thank you for confirming your scheduled dates. The sender of this schedule has been notified of your confirmation.
            </div>
            <div className='flex gap-4'>
              <button  
                className={`border border-[#888] hover:border-[#000] hover:bg-[#000] text-white w-full py-[7px] font-bold select-none rounded-lg`}
                onClick={() => {
                  try { confirmedShareScheduleContactDates(false); } catch(error) {}
                }}
              >
                Undo Confirmation
              </button>
              <PushButton 
                textColor={`black`}
                bgColor={'#f9a928'}
                hoverBgColor={'#f79800'}
                onClick={() => { closeDialogue(); }}
              >
                Close
              </PushButton>
            </div>
          </div>
          :
          <div className='flex flex-col gap-y-4 w-[90vw] max-w-full'>
            <div>
              Confirm that you've reviewed the scheduled work dates for: 
            </div>
            <div className='font-bold p-2'>
              <div>{_confirmWorkDatesDialogueCompanyName}</div>
              <div>{_confirmWorkDatesDialogueFirstName} {_confirmWorkDatesDialogueLastName}</div>
              <div>{_confirmWorkDatesDialogueEmail}</div>
            </div>
            <div>
              and can complete the work as scheduled.
            </div>
            <div className='flex gap-4'>
              <button  
                className={`border border-[#888] hover:border-[#000] hover:bg-[#000] text-white w-full py-[7px] font-bold select-none rounded-lg`}
                onClick={() => { closeDialogue(); }}
              >
                Cancel
              </button>
              <PushButton 
                textColor={`black`}
                bgColor={'#f9a928'}
                hoverBgColor={'#f79800'}
                onClick={() => {
                  try { confirmedShareScheduleContactDates(true); } catch(error) {}
                }}
              >
                <div className='flex items-center gap-x-[6px]'>
                  <div>Confirm Work Dates</div>
                </div>
              </PushButton>
            </div>
          </div>
        }
      </div>
    </PopupWindow>
  );
};

// define redux state that will be passed in as props
const mapStateToProps = state => { return {
  _confirmWorkDatesDialogueEmail: state.localEphemeral.confirmWorkDatesDialogueEmail,
  _confirmWorkDatesDialogueFirstName: state.localEphemeral.confirmWorkDatesDialogueFirstName,
  _confirmWorkDatesDialogueLastName: state.localEphemeral.confirmWorkDatesDialogueLastName,
  _confirmWorkDatesDialogueCompanyName: state.localEphemeral.confirmWorkDatesDialogueCompanyName,
  _confirmWorkDatesDialogueShareScheduleCode: state.localEphemeral.confirmWorkDatesDialogueShareScheduleCode,
  _shareScheduleConfirmed: state.localEphemeral.shareScheduleConfirmed,
}};
export default connect(mapStateToProps, { siteboardAction, setLoading, })(ConfirmWorkDatesDialogue);
